import script from "./PersonalizedEmailsViewV3.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalizedEmailsViewV3.vue?vue&type=script&setup=true&lang=js"

import "./PersonalizedEmailsViewV3.vue?vue&type=style&index=0&id=1429ca81&lang=scss"

const __exports__ = script;

export default __exports__